import { dispatchAndUnwrap } from 'helpers/api';
import { masterDataApi } from 'services/masterDataApi';
import {
  logonUrlHasBeenSet,
  setEmployeeLogonUrl,
  setUserShugoLogonUrl,
} from 'store/appSlice';

export async function setLogonUrl(dispatch) {
  const shugoTestConditions = ['myfileguardian.com', 'workforcehubqa.com'];
  const docReferrer = document.referrer;

  if (
    !!docReferrer &&
    shugoTestConditions.some((str) => docReferrer.includes(str))
  ) {
    const employeeResult = await dispatchAndUnwrap(
      dispatch,
      masterDataApi.endpoints.getLoginUrl,
      {}
    );

    dispatch(
      setEmployeeLogonUrl({
        employeeLogonUrl: employeeResult?.employeeLogonUrl,
      })
    );
  } else {
    dispatch(
      setUserShugoLogonUrl({
        useShugoLogonUrl: true,
      })
    );
  }

  // Important for checking if logon related values are good
  // to get from the store in loaders. See feature/router loadingHelpers.js
  dispatch(logonUrlHasBeenSet(true));
}
